// Sistema de títulos de níveis
export const LEVEL_TITLES = {
  0: { name: "Iniciante", description: "Primeiros passos na jornada fitness" },
  10: { name: "Atleta", description: "Dedicação inicial, foco em disciplina" },
  20: { name: "Treinador Interno", description: "Começa a dominar técnicas e rotinas" },
  30: { name: "Explorador do Corpo", description: "Experimenta diferentes treinos e estilos" },
  40: { name: "Guardião da Saúde", description: "Prioriza bem-estar e equilíbrio" },
  50: { name: "Construtor de Força", description: "Desenvolvimento muscular e resistência" },
  60: { name: "Estrategista Fitness", description: "Planejamento avançado de treinos e metas" },
  70: { name: "Mestre da Energia", description: "Controle de performance e vitalidade" },
  80: { name: "Campeão do Movimento", description: "Reconhecido pela excelência física" },
  90: { name: "Arconte Fitness", description: "Figura lendária, inspiração máxima" },
};

export const getLevelTitle = (level) => {
  const thresholds = [90, 80, 70, 60, 50, 40, 30, 20, 10, 0];
  
  for (const threshold of thresholds) {
    if (level >= threshold) {
      return LEVEL_TITLES[threshold];
    }
  }
  
  return LEVEL_TITLES[0];
};

export const getNextLevelThreshold = (level) => {
  const thresholds = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  
  for (const threshold of thresholds) {
    if (level < threshold) {
      return threshold;
    }
  }
  
  return 100;
};

// Pontos necessários para cada nível: sempre 500
export const XP_PER_LEVEL = 500;
